import moment from 'moment';

class ShippingRulesMapper {
  /**
   * Takes a IShippingRuleApiResponse from Packlink's API and returns a IShippingRule.
   *
   * @param response IShippingRuleApiResponse response from Packlink's API.
   *
   */

  static createRuleFromResponse(response) {
    if (!response) {
      return undefined;
    }
    return {
      id: response.id,
      alias: response.alias,
      enabled: response.enabled,
      conditions: response.conditions,
      actions: response.actions,
      updated: moment(response.updatedAt)
    };
  }
}

export { ShippingRulesMapper };
//# sourceMappingURL=ShippingRulesMapper.js.map
